// Common constants used throughout the application

import { SYSTEM_TAGS, isSystemTag, MAX_UPLOAD_FILE_SIZE } from '@loader/shared-types';

export const PAGINATION_OPTIONS = [10, 20, 30, 40, 50] as const;

// Re-export shared constants and utilities for convenience
export { SYSTEM_TAGS, isSystemTag };

export const STATUS_TYPES = [
  'active',
  'archived',
  'error',
  'processing',
  'completed',
  'failed',
] as const;

export const ISSUE_SEVERITIES = ['error', 'warning', 'info'] as const;

export const ISSUE_TYPES = ['validation', 'schema', 'data'] as const;

export const ACTIVITY_TYPES = [
  'version',
  'schema_change',
  'error',
  'user_action',
] as const;

export const INSIGHT_TYPES = ['trend', 'anomaly', 'summary'] as const;

export const USER_ROLES = ['admin', 'member', 'viewer'] as const;

export const RECENT_TABLES_LIMIT = 5;

// Re-export with backwards-compatible name
export { MAX_UPLOAD_FILE_SIZE as MAX_FILE_SIZE };

/**
 * API Base URL Configuration
 *
 * Centralized configuration for the API base URL.
 * Loaded once at application startup from environment variables.
 * Defaults to localhost:8787 for local development.
 */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8787';

/**
 * Billing Constants
 */

/**
 * Yearly billing discount percentage
 * Displayed to users when selecting yearly billing interval
 */
export const YEARLY_DISCOUNT_PERCENTAGE = 17;
